import request from './request_manager'
import auth from '../auth'
import store from '../store'
import axios from 'axios'

export default {

  login (email, password) {
    return request.post('auth/login', { 'email': email, 'password': password })
  },

  extractUserIdFromToken(token) {

    try {
      let payloadString = token.split('.')[1];
      let base64 = payloadString.replace(/-/g, '+').replace(/_/g, '/');
      let map = JSON.parse(window.atob(base64));

      let id = map['sub'];

      return id;

    } catch (e) {
      // console.log('error extracting id from token', e);
      return 0
    }

  },

  getRequestAuthHeaders() {
    const token = auth.getToken();
    return { 'Authorization': `Bearer ${token}` }
  },

  getUserId() {
    const token = auth.getToken();
    return this.extractUserIdFromToken(token)
  },

  async getUser () {
    try {

      const token = auth.getToken();
      let config = { headers: this.getRequestAuthHeaders() };
      let id = this.extractUserIdFromToken(token);

      let response = await request.get(`users/${id}`, config);

      let user = response.data.data;
      await store.commit('setUser', user);

      return user
    } catch {
      return null
    }

  },


  async getDeclinedPayment () {

    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.get(`users/${this.getUserId()}/declined-payment`, config);
    let value = response.data.data;

    if (value.amount === false) value = null;
    // console.log("getDeclinedPayment response", value);

    store.commit('setDeclinedPayment', value);

    return value;
  },

  async getCcInfo () {
    // await new Promise(resolve => setTimeout(resolve, 500))

    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.get(`users/${this.getUserId()}/credit-card`, config);

    if (!response.data.hasOwnProperty('data') || !response.data.data.hasOwnProperty('last_four')) return { last_four: '', exp: '' };
    let value = response.data.data;

    // console.log("getCcInfo response", value);

    store.commit('setCcInfo', value);

    return value
  },

  async getBillingHistory () {

    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.get(`users/${this.getUserId()}/billing-history`, config);
    if (!response.data.hasOwnProperty('data') || !response.data.data.hasOwnProperty('billing_history')) return [];

    let value = response.data.data.billing_history;
    if (!Array.isArray(value)) value = [];

    // console.log("billing-history response", value);

    store.commit('setBillingHistory', value);

    return value
  },

  async getNextPayment () {

    let config = { headers: this.getRequestAuthHeaders() };

    let response = await request.get(`users/${this.getUserId()}/next-payment-info`, config);
    // console.log("getNextPayment response", response);
    if (!response.data.hasOwnProperty('data')) return {};

    let value = response.data.data;
    if (!value.hasOwnProperty('date') || !value.hasOwnProperty('amount')) return {};
    store.commit('setNextPayment', value);

    return value
  },

  async getClients () {

    let config = { headers: this.getRequestAuthHeaders() };

    let response = await request.get(`users/${this.getUserId()}/clients`, config);
    // console.log("getNextPayment response", response);
    if (!response.data.hasOwnProperty('data')) return [];

    let value = response.data.data;

    if (!Array.isArray(value)) value = [];

    store.commit('setClients', value);

    return value
  },

  async getEmailNotifications () {

    let value = [];
    let config = { headers: this.getRequestAuthHeaders() };
    try {
      let response = await request.get(`users/${this.getUserId()}/email-notifications`, config);
      value = response.data.data;
      // console.log("getEmailNotifications response", value);
      store.commit('setEmailNotifications', value)
    } catch (e) {
      // a 500 is fine here (should only happen on test accounts)
    }



    return value
  },

  async getPlanDetails () {

    // await new Promise(resolve => setTimeout(resolve, 500))
    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.get(`users/${this.getUserId()}/plan-details`, config);
    // console.log("getPlanDetails response", response);
    if (!response.data.hasOwnProperty('data') || !response.data.data.hasOwnProperty('name')) return [];
    let value = response.data.data;
    // return response.data.data

    store.commit('setPlanDetails', value);

    return value
  },


  async getPlanAddOns () {

    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.get(`users/${this.getUserId()}/add-ons`, config);
    //console.log("getPlanAddOns response", response);
    if (!response.data.hasOwnProperty('data')) return { applied: [], available: [] };
    let value = response.data.data;

    store.commit('setAddOns', value);

    return value
  },


  async sendPasswordReset (email) {
    // this endpoint uses a different api
    let axiosInstance = axios.create({
      baseURL: `https://secure.itovi.com/api/`
    });

    let config = {  };
    let response = await axiosInstance.get(`user/send-password-reset/${encodeURIComponent(email)}`, config);
    // console.log("sendPasswordReset response", response);
    if (!response.data.hasOwnProperty('success')) return false ;

    return response.data.success;
  },


  async getReferralProgram () {

    let config = { headers: this.getRequestAuthHeaders() };

    let response = await request.get(`users/${this.getUserId()}/referral-program`, config);
    // console.log("referral-program response", response);
    if (!response.data.hasOwnProperty('data')) return {};

    let value = response.data.data;
    if (!value.hasOwnProperty('buckets') || !value.hasOwnProperty('referral_count')) return {};

    store.commit('setReferralProgram', value);


    return value
  },

  async payPastDueBill () {

    let success = false;
    let errorText = '';
    let config = { headers: this.getRequestAuthHeaders() };
    try {
      let response = await request.post(`users/${this.getUserId()}/declined-payment`, { }, config);
      // console.log("payPastDueBill response", response);
      success = response.status === 200 && response.data.success === true;
      if (!success) {
        errorText = response.data.errors[0].errorText
      }
    } catch (e) {
      success = false
    }

    if (success) {
      // await this.getUser()
      await Promise.all([
        this.getPlanDetails(),
        this.getPlanAddOns(),
        this.getBillingHistory(),
        this.getNextPayment(),
      ]);
    }

    return {
      success: success,
      errorMessage: errorText
    }
  },

  async submitCcChange (data) {
    let config = { headers: this.getRequestAuthHeaders() };
    let success = false;
    let errorMessages = [];

    try {
      let response = await request.patch(`users/${this.getUserId()}/credit-card`, data, config);
      success = response.status === 200;
    } catch (error) {
      errorMessages = error.response.data.errors;
    }

    await this.getCcInfo();

    return {
      success: success,
      errors: errorMessages
    }
  },


  async submitBillingAddressChange (data) {

    let config = { headers: this.getRequestAuthHeaders() };
    let errorMessage = '';
    let success = false;

    try {
      let response = await request.patch(`users/${this.getUserId()}/addresses/billings`, data, config);
      // console.log("submitBillingAddressChange response", response);
      success = response.status === 200;
      if (success) await this.getUser()
    } catch (e) {
      success = false;
      errorMessage = 'Invalid Address'
    }


    return {
      success: success,
      errorMessage: errorMessage
    }
  },
  async submitShippingAddressChange (data) {

    let config = { headers: this.getRequestAuthHeaders() };
    let errorMessage = '';
    let success = false;

    try {
      let response = await request.patch(`users/${this.getUserId()}/addresses/shippings`, data, config);
      // console.log("submitShippingAddressChange response", response);
      success = response.status === 200;
      if (success) await this.getUser()
    } catch (e) {
      success = false;
      errorMessage = 'Invalid Address'
    }


    return {
      success: success,
      errorMessage: errorMessage
    }
  },

  async submitPasswordChange (password) {

    let config = { headers: this.getRequestAuthHeaders() };
    let response = await request.patch(`users/${this.getUserId()}`, { password: password }, config);
    // console.log("submitPasswordChange response", response);

    const success = response.status === 200;

    return {
      success: success,
      errorMessage: ''
    }
  },

  async submitPlanChange (product_code) {

    let success = false;
    let errorText = '';
    let config = { headers: this.getRequestAuthHeaders() };
    try {
      let response = await request.post(`users/${this.getUserId()}/change-plan`, {product_code: product_code }, config);

      success = response.status === 200 && response.data.success === true;
      if (!success) {
        errorText = response.data.errors[0].errorText
      }
    } catch (e) {
      success = false
    }

    if (success) {
      // await this.getUser()
      await Promise.all([
        this.getPlanDetails(),
        this.getPlanAddOns(),
        this.getBillingHistory(),
        this.getNextPayment(),
      ]);
    }

    return {
      success: success,
      errorMessage: errorText
    }
  },

  async submitAddOnPurchase (addOns) {
    let success = false;
    let errorText = '';
    let config = { headers: this.getRequestAuthHeaders() };
    try {
      let products = [];
      for (let i = 0; i < addOns.length; i++) {
        products.push({ prod_id: addOns[i].id, yearly: (addOns[i].inCart === "annually") });
      }
      let source = (store.state.initialUrlParameters.hasOwnProperty('status') && store.state.initialUrlParameters.status === 'referencebooks') ? 'product_page' : null;

      let response = await request.post(`users/${this.getUserId()}/add-ons`, {source: source, products: products }, config);
      // console.log("submitAddOnPurchase response", response);
      success = response.status === 200 && response.data.success === true;
      if (!success) {
        errorText = response.data.errors[0].errorText || response.data.errors[0];
      }
    } catch (e) {
      success = false;
    }

    if (success) {
      // await this.getUser()
      await Promise.all([
        this.getPlanDetails(),
        this.getPlanAddOns(),
        this.getBillingHistory(),
        this.getNextPayment(),
      ]);
    }

    return {
      success: success,
      errorMessage: errorText
    }
  },
  async submitAddOnCancel (addOnId) {

    let success = false;
    let errorText = '';
    let config = { headers: this.getRequestAuthHeaders() };
    try {
      let response = await request.post(`users/${this.getUserId()}/add-ons/cancel`, { prod_id: addOnId }, config);
      // console.log("submitAddOnPurchase response", response);
      success = response.status === 200 && response.data.success === true;
      if (!success) {
        errorText = response.data.errors[0].errorText;
      }
    } catch (e) {
      success = false;
    }

    if (success) {
      await Promise.all([
        this.getPlanDetails(),
        this.getPlanAddOns(),
        this.getBillingHistory(),
        this.getNextPayment(),
      ]);
    }

    return {
      success: success,
      errorMessage: errorText
    }
  },

  async submitPushNotificationChange (receivePushes) {

    let config = { headers: this.getRequestAuthHeaders() };

    let response = await request.patch(`users/${this.getUserId()}`, { push_notifications: receivePushes }, config);
    // console.log("submitPushNotificationChange response", response);

    const success = response.status === 200;

    if (success) await this.getUser();

    return {
      success: success,
      errorMessage: ''
    }

  },

  async submitEmailNotificationChange (id, value) {

    let config = { headers: this.getRequestAuthHeaders() };

    let response = await request.patch(`users/${this.getUserId()}/email-notifications`, { id: id, value: value }, config);
    // console.log("submitEmailNotificationChange response", response);

    const success = response.status === 200;

    // if (success) await this.getEmailNotifications()

    return {
      success: success,
      errorMessage: ''
    }

  },

  async reActivateAccount () {
    let config = {headers: this.getRequestAuthHeaders()};
    let response = await request.post(`users/${this.getUserId()}/declined-payment`, config);
    return response.data;
  },

  /**
   * @param { Number } id
   * @return {Promise<*>}
   */
  async reactivateAddOn (id) {
    let config = {headers: this.getRequestAuthHeaders()};
    let response = await request.patch(`users/${this.getUserId()}/add-ons/reactivate`, {prod_id: id}, config);
    return response.data;
  },

  async getPlusOneClients() {
    let config = {headers: this.getRequestAuthHeaders()};
    let response = await request.get(`users/${this.getUserId()}/clients/plus-one/all-assigned`, config);

    if (response.status !== 200 || !response.hasOwnProperty('data')) return;
    //Filter out me client
    if (store.state.user) {
      const clients = response.data.clients.filter((client) => client.id !== store.state.user.client.id);
      store.commit('setPlusOneClients', {...response.data, clients: clients});
    }
  },

  /**
   * @param { number } clientId
   * @return {Promise<boolean>}
   */
  async assignPlusOne(clientId) {
    let config = {headers: this.getRequestAuthHeaders()};
    let response = await request.put(`users/${this.getUserId()}/clients/plus-one/${clientId}`, {}, config);
    return response.status === 200;
  },

  /**
   * @param { number } clientId
   * @return {Promise<boolean>}
   */
  async deletePlusOne(clientId) {
    let config = {headers: this.getRequestAuthHeaders()};
    let response = await request.delete(`users/${this.getUserId()}/clients/plus-one/${clientId}`, {}, config);
    return response.status === 200;
  },

   async refreshDashboard () {
    await Promise.all([
      this.getUser(),
      this.getPlanDetails(),
      this.getDeclinedPayment(),
      this.getCcInfo(),
      this.getBillingHistory(),
      this.getNextPayment(),
      this.getReferralProgram(),
      this.getPlusOneClients()
    ]);
  }
};
